import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './configureStore';
import {
  preserveUndoableState,
  performRedo,
  performUndo,
} from './reducers/experimentDataReducer';
import {
  preserveDeletedLayerUndoableState,
  performDeletedLayerRedo,
  performDeletedLayerUndo,
} from './reducers/layerReducer';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useRMDispatch = () => useDispatch<AppDispatch>();
export const useRMSelector: TypedUseSelectorHook<RootState> = useSelector;

export const usePreserveExperiment = () => {
  const dispatch = useRMDispatch();
  return () => {
    dispatch(preserveUndoableState());
    dispatch(preserveDeletedLayerUndoableState());
  };
};

export function useUndoExperiment() {
  const dispatch = useRMDispatch();
  return () => {
    dispatch(performUndo());
    dispatch(performDeletedLayerUndo());
  };
}

export const useRedoExperiment = () => {
  const dispatch = useRMDispatch();
  return () => {
    dispatch(performRedo());
    dispatch(performDeletedLayerRedo());
  };
};
